// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d436c83e","239":"82b3b451","453":"26460427","667":"2415ad92"}[chunkId] + ".chunk.js";
};